import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Удаляет существующую группу промокодов из системы
 * @tags PromocodeGroups
 * @summary Удаление группы промокодов
 */
export const PromocodeGroupDeleteContentType = '' as const;
export type PromocodeGroupDeleteRequest = void;
export type PromocodeGroupDeleteResponses = LinkCommonErrorResponses & {
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupDeleteResponseSuccess = undefined;
export type PromocodeGroupDeleteSearchParams = undefined;
export type PromocodeGroupDeletePathParameters = {
    id: string;
};
export const PromocodeGroupDeleteUrl = '/promocode_groups/{id}' as const;
export const PromocodeGroupDeleteMethod = 'DELETE' as const;
export const getPromocodeGroupDeleteUrl = (params: PromocodeGroupDeletePathParameters) =>
    PromocodeGroupDeleteUrl.replace(/\{(\w+)\}/g, (_match, param: keyof PromocodeGroupDeletePathParameters) =>
        String(params[param])
    );
